'use client';

import { Info, Merge, Trash2 } from 'lucide-react';
import UserModerationModal from './UserModerationModal';
import DeleteAccountModal from './DeleteAccountModal';
import MergeAccountModal from './MergeAccountModal';

/**
 * Moderator actions on a profile page: account details, merge, delete.
 *
 * The three are separate sibling modals rather than one modal containing the
 * others. Nesting them would break the click-outside handler — a click inside
 * the inner modal falls outside the outer one's ref and would close both.
 *
 * Delete and merge both redirect to the home page on success: this component
 * renders on the profile of the account being removed, so refreshing in place
 * would land on a 404.
 */
export default function UserModerationFAB({
  email,
  userId,
  username,
}: {
  email: string;
  userId: string;
  username: string | null;
}) {
  return (
    // Above the players (z-20 on the docked TonePlayer, z-30 on PlayerInfo), which
    // otherwise cover these buttons on a profile full of tone cards. Below the
    // z-40 modal band, so an open dialog's backdrop still covers the FAB.
    <div className="fixed bottom-6 right-6 z-[35] flex flex-col gap-3">
      <DeleteAccountModal
        userId={userId}
        username={username}
        redirectTo="/"
        trigger={
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-500 shadow-lg transition-colors duration-200 hover:bg-red-600">
            <Trash2 className="h-5 w-5 text-white" />
          </div>
        }
      />
      <MergeAccountModal
        sourceId={userId}
        sourceUsername={username}
        redirectTo="/"
        trigger={
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-zinc-700 shadow-lg transition-colors duration-200 hover:bg-zinc-600">
            <Merge className="h-5 w-5 text-white" />
          </div>
        }
      />
      <UserModerationModal
        title="User Details"
        email={email}
        trigger={
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-lg">
            <Info className="h-5 w-5 text-black" />
          </div>
        }
      />
    </div>
  );
}
